import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import LogoSelector from "../components/LogoSelector/LogoSelector";

export default function BrandAssets() {
	const { translate } = useLocales();
	return (
		<Stack>
			<Typography variant='h6' sx={{ mb: 2 }}>
				{translate("customization.brand_options")}
			</Typography>
			<LogoSelector />
		</Stack>
	);
}
